import { render, staticRenderFns } from "./ProductValueProps.vue?vue&type=template&id=437267d4&scoped=true&lang=pug&"
import script from "./ProductValueProps.vue?vue&type=script&lang=js&"
export * from "./ProductValueProps.vue?vue&type=script&lang=js&"
import style0 from "./ProductValueProps.vue?vue&type=style&index=0&id=437267d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437267d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('437267d4')) {
      api.createRecord('437267d4', component.options)
    } else {
      api.reload('437267d4', component.options)
    }
    module.hot.accept("./ProductValueProps.vue?vue&type=template&id=437267d4&scoped=true&lang=pug&", function () {
      api.rerender('437267d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/bourdain/ProductValueProps.vue"
export default component.exports